'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { EXIT_INTENT_SIGNAL, IDLE_SECONDS } from '../constants';
import { type ExitIntentTrigger, hasExitIntentBeenShown } from '../utils/session';
const IDLE_ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'click', 'scroll'] as const;
export function useIdleSignal(triggerRef, hasFired) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== hasFired || $[1] !== triggerRef) {
    t0 = () => {
      if (hasFired || hasExitIntentBeenShown()) {
        return;
      }
      let idleTimeoutId;
      const armIdleTimer = () => {
        clearTimeout(idleTimeoutId);
        idleTimeoutId = setTimeout(() => {
          triggerRef.current?.(EXIT_INTENT_SIGNAL.idle);
        }, IDLE_SECONDS * 1000);
      };
      armIdleTimer();
      for (const event of IDLE_ACTIVITY_EVENTS) {
        window.addEventListener(event, armIdleTimer);
      }
      return () => {
        clearTimeout(idleTimeoutId);
        for (const event_0 of IDLE_ACTIVITY_EVENTS) {
          window.removeEventListener(event_0, armIdleTimer);
        }
      };
    };
    t1 = [triggerRef, hasFired];
    $[0] = hasFired;
    $[1] = triggerRef;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}